import { Injectable } from '@angular/core';
import { ValueService, NotificationService } from '@oa/shared-core';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable({
  providedIn: "root",
})
export class ErrorHelperService {
  private readonly _serviceName = 'ErrorHelperService';

  constructor(private valueHelper: ValueService, private notify: NotificationService) {}

  /**
   * Gets the individual validation error messages from an Error object
   * @param err
   */
  getModelValidationErrorMessages(err: any): string[] {
    const msgs = [];

    if (err && err['exceptionType'] === 'ModelValidation') {
      if (err.data && err.data.fields) {
        var keys = Object.keys(err.data.fields);
        // console.log("keys", keys);

        keys.forEach((key) => {
          var x = err.data.fields[key] as Array<any>;
          x.forEach((item) => {
            msgs.push(item);
          });
        });
      }
    }

    return msgs;
  }

  /**
   * Selects out a string array of validation messages from a validation error object
   * @param err
   */
  public getValidationErrorMessages(err: any): string[] {
    const msgs = [];

    if (err && err.data && err.data.errors) {
      err.data.errors.forEach((item) => {
        if (item && item.errorMessage) {
          msgs.push(item.errorMessage);
        }
      });
    }

    return msgs;
  }

  public getErrorMessage(err: any): string {
    if (typeof err === 'string') {
      return err;
    }

    let msg = this.valueHelper.getSafeValue(err, 'error.message');

    if (!msg) {
      msg = this.valueHelper.getSafeValue(err, 'message');
    }

    return msg;
  }

  public handleError(error: HttpErrorResponse) {
    

    let msg = 'An error occurred'; // not all that helpful, but an initial value

    console.error(error);

    //To know the version of RxJS npm list --depth=0 (I for this example im on version 5.5)
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred: ', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,

      switch (error.status) {
        case 422:
          // Often 422 - unprocessible entity - is a validation failure on the server/backend
          if (error.error) {
            msg = error.error + '';
          }

          break;

        default:
          break;
      }

      if (!msg) {
        const m = this.getErrorMessage(error);
        if (m) {
          msg = m;
        }
      }

      console.error(`Backend returned code ${error.status}` + ` body was: ${error.message}`);
    }

    if (msg) {
      this.notify.error(msg, null);
    }

    // if (errorRepsonse.status === 422){}

    // let msg = this.errorHelper.getErrorMessage(err) || 'An subscription error occured';
    // console.error(err);
    // 
    // this.notify.error(msg,null);
  }
}
